import { datetimeFormats } from "@/entrypoints/shared/i18n_constants";
import type { Locale } from "@/types";

import ar from "../../locales/ar.backend_translations.json";
import da from "../../locales/da.backend_translations.json";
import de from "../../locales/de.backend_translations.json";
import en from "../../locales/en.backend_translations.json";
import es from "../../locales/es.backend_translations.json";
import fr from "../../locales/fr.backend_translations.json";
import ca from "../../locales/ca.backend_translations.json";
import fi from "../../locales/fi.backend_translations.json";
import is from "../../locales/is.backend_translations.json";
import pl from "../../locales/pl.backend_translations.json";
import pt from "../../locales/pt.backend_translations.json";
import ro from "../../locales/ro.backend_translations.json";
import ru from "../../locales/ru.backend_translations.json";
import sv from "../../locales/sv.backend_translations.json";

// TS won't accept another import than default for JSON
const messages = {
  ar: ar.ar,
  ca: ca.ca,
  da: da.da,
  de: de.de,
  en: en.en,
  es: es.es,
  fr: fr.fr,
  fi: fi.fi,
  is: is.is,
  pl: pl.pl,
  pt: pt.pt,
  ro: ro.ro,
  ru: ru.ru,
  sv: sv.sv
};

import { createI18n } from 'vue-i18n';

// If js i18n environment is not configured, we default to english
if (!window.__i18n) {
  window.__i18n = {
    locale: 'en',
    available: ['en'],
    translations: { en: {} }
  }
};

const i18n = createI18n<false>({
  locale: window.__i18n ? window.__i18n.locale : 'en',
  messages,
  fallbackLocale: 'en',
  datetimeFormats,
  warnHtmlInMessage: 'off',
});

window.__i18n.instance = i18n;

// Merge in custom js translations
window.__i18n.available.forEach((locale: Locale) => {
  if (window.__i18n.translations[locale]) {
    i18n.global.mergeLocaleMessage(locale, window.__i18n.translations[locale])
  }
});

export { i18n };

export default i18n;
